import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import addBook from '../redux/books/thunk/addBook';
import updateBook from '../redux/books/thunk/updateBook';

function BookForm() {
    //States
    const [formValues, setFormValues] = useState({
        name: "",
        author: "",
        thumbnail: "",
        price: "",
        rating: "",
        featured: false
    });
    
    //Hooks
    const dispatch = useDispatch();
    const book = useSelector((state) => state.books.book);

    useEffect(() => {
        const { name, author, thumbnail, price, rating, featured } = book;
        setFormValues({
            name, author, thumbnail, price, rating, featured
        })
    }, [book])

    //Function
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: name === 'featured' ? !formValues.featured : value });
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        const { name, author, thumbnail, price, rating, featured } = formValues;
        if (name && author && thumbnail && price && rating) {
            const payload = { name, author, thumbnail, price, rating, featured };
            if (book.id) {
                dispatch(updateBook(book.id, payload));
            } else {
                dispatch(addBook(payload));
            }
            setFormValues({
                name: "",
                author: "",
                thumbnail: "",
                price: "",
                rating: "",
                featured: false
            });
        }
    };

    const { name, author, thumbnail, price, rating, featured } = formValues;
    return (
        <div>
            <div className="p-4 overflow-hidden bg-white shadow-cardShadow rounded-md">
                <h4 className="mb-8 text-xl font-bold text-center">Add New Book</h4>
                <form className="book-form" onSubmit={handleSubmit}>
                    <div className="space-y-2">
                        <label for="name">Book Name</label>
                        <input required className="text-input" type="text" id="input-Bookname" name="name" value={name} onChange={handleInputChange} />
                    </div>

                    <div className="space-y-2">
                        <label for="category">Author</label>
                        <input required className="text-input" type="text" id="input-Bookauthor" name="author" value={author} onChange={handleInputChange} />
                    </div>

                    <div className="space-y-2">
                        <label for="image">Image Url</label>
                        <input required className="text-input" type="text" id="input-Bookthumbnail" name="thumbnail" value={thumbnail} onChange={handleInputChange} />
                    </div>

                    <div className="grid grid-cols-2 gap-8 pb-4">
                        <div className="space-y-2">
                            <label for="price">Price</label>
                            <input required className="text-input" type="number" id="input-Bookprice" name="price" value={price} min="0" onChange={handleInputChange} />
                        </div>

                        <div className="space-y-2">
                            <label for="quantity">Rating</label>
                            <input required className="text-input" type="number" id="input-Bookrating" name="rating" value={rating} min="1" max="5" onChange={handleInputChange} />
                        </div>
                    </div>

                    <div className="flex items-center">
                        <input id="input-Bookfeatured" type="checkbox" name="featured" className="w-4 h-4" checked={featured} value={featured} onChange={handleInputChange} />
                        <label for="featured" className="ml-2 text-sm"> This is a featured book </label>
                    </div>

                    <button type="submit" className="submit" id="submit">{book?.id ? 'Update' : 'Add'} Book</button>
                </form>
            </div>
        </div>
    )
}

export default BookForm